import React, { useState } from 'react';
import Select from 'react-select';
import { X, Calendar, User } from 'lucide-react';

const FUPModal = ({ empresa, companyContacts = [], onClose, onSave }) => {
  // Pré-seleciona o contato vinculado ao FUP atual (se existir)
  const [selectedContactId, setSelectedContactId] = useState(
    empresa?.fup_contato_id || companyContacts[0]?.id
  );
  const [date, setDate] = useState(empresa?.data_fup || '');
  const [nextStep, setNextStep] = useState(empresa?.fup_proximo_passo || '');
  const [isSaving, setIsSaving] = useState(false);

  // Opções de contatos para o Select
  const contactOptions = companyContacts.map(c => ({
    value: c.id,
    label: `${c.first_name} ${c.last_name || ''} ${c.title ? `(${c.title})` : ''}`.trim()
  }));

  const currentOption = contactOptions.find(opt => opt.value === selectedContactId);

  const handleSave = async () => {
    if (!selectedContactId) {
      alert('Selecione um contato para o FUP.');
      return;
    }
    
    setIsSaving(true);
    
    // Atualiza a EMPRESA com os dados do FUP
    await onSave({
      data_fup: date || null,
      fup_contato_id: selectedContactId,
      fup_proximo_passo: nextStep || null
    });
    
    setIsSaving(false);
  };

  return (
    <div className="fixed inset-0 bg-black/50 backdrop-blur-sm flex items-center justify-center z-[10000]">
      <div className="bg-white rounded-lg shadow-xl w-full max-w-xl p-6">
        {/* Header */}
        <div className="flex justify-between items-center mb-6">
          <div>
            <h2 className="text-xl font-bold text-slate-800 flex items-center gap-2">
              <Calendar className="text-orange-500" />
              Agendar Follow-up
            </h2>
            <p className="text-sm text-slate-500 mt-1">{empresa?.empresa}</p>
          </div>
          <button onClick={onClose} className="text-slate-400 hover:text-slate-600">
            <X size={24} />
          </button>
        </div>

        <div className="space-y-4">
          {/* Seleção de Contato */}
          <div>
            <label className="block text-sm font-medium text-slate-700 mb-1 flex items-center gap-1">
              <User size={14}/> Contato Responsável *
            </label>
            <Select
              options={contactOptions}
              value={currentOption}
              onChange={(opt) => setSelectedContactId(opt?.value)}
              className="text-sm"
              placeholder="Selecione o contato..."
              isClearable={false}
            />
          </div>

          {/* Data do FUP */}
          <div>
            <label className="block text-sm font-medium text-slate-700 mb-1">
              Data do Follow-up
            </label>
            <input
              type="date"
              value={date}
              onChange={(e) => setDate(e.target.value)}
              className="w-full border border-slate-300 rounded-md p-2 focus:ring-2 focus:ring-orange-500 outline-none"
            />
            <button 
              onClick={() => setDate('')} 
              className="text-xs text-slate-400 hover:text-red-500 mt-1 underline"
            >
              Limpar data
            </button>
          </div>

          {/* Próximo Passo */}
          <div>
            <label className="block text-sm font-medium text-slate-700 mb-1">
              Próximo Passo / Anotação
            </label>
            <textarea
              value={nextStep}
              onChange={(e) => setNextStep(e.target.value)}
              rows={5}
              placeholder="Descreva o contexto e o próximo passo..."
              className="w-full border border-slate-300 rounded-md p-2 focus:ring-2 focus:ring-orange-500 outline-none resize-y min-h-[100px]"
            />
          </div>
        </div>

        {/* Botões */}
        <div className="mt-6 flex justify-end gap-3">
          <button 
            onClick={onClose} 
            className="px-4 py-2 text-slate-600 hover:bg-slate-100 rounded-md"
          >
            Cancelar
          </button>
          <button 
            onClick={handleSave}
            disabled={isSaving}
            className="px-4 py-2 bg-orange-600 hover:bg-orange-700 text-white rounded-md font-medium disabled:opacity-50 disabled:cursor-not-allowed flex items-center gap-2"
          >
            {isSaving ? (
              <>
                <span className="animate-spin">⏳</span>
                Salvando...
              </>
            ) : (
              'Salvar Follow-up'
            )}
          </button>
        </div>
      </div>
    </div>
  );
};

export default FUPModal;